import type { CustomFieldCondition } from "@repo/app-types/entities/filterConditions";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Size } from "@repo/ui/helpers/helpers";
import { Input } from "@repo/ui/Inputs/input";
import { type FC, useContext, useState } from "react";
import { RootMenuTriggerStateContext } from "react-aria-components";

export interface StringCustomFieldConditionMenuProps {
  customFieldDefinitionId: string;
  onSelect: (condition: CustomFieldCondition) => void;
}

export const StringCustomFieldConditionMenu: FC<
  StringCustomFieldConditionMenuProps
> = (props) => {
  const rootMenuTriggerState = useContext(RootMenuTriggerStateContext);
  const [value, setValue] = useState("");

  const handleApply = () => {
    props.onSelect({
      customFieldDefinitionId: props.customFieldDefinitionId,
      operator: "=",
      value,
    });

    rootMenuTriggerState?.close();
  };

  return (
    <div className="flex gap-2 px-3 py-2">
      <Input
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder="Enter value"
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            handleApply();
          }
        }}
        maxLength={255}
      />

      <div className="flex justify-end">
        <Button
          size={Size.MEDIUM}
          variant={ButtonVariant.Primary}
          isDisabled={!value}
          onClick={handleApply}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};
